import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../messages';
import { CONTENT_URL_3P_ACCOUNT_AUTH, CONTENT_URL_SECURITY_AND_PERMISSIONS } from '../../constants';
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */
const UnauthorisedViewContent = ({
  providerName,
  isProductIntegrationSupported,
  testId = 'unauthorised-view-content',
  analytics
}) => {
  const handleLearnMoreClick = useCallback(() => {
    analytics === null || analytics === void 0 ? void 0 : analytics.ui.learnMoreClickedEvent();
  }, [analytics === null || analytics === void 0 ? void 0 : analytics.ui]);
  const learnMoreMessage = isProductIntegrationSupported ? messages.learn_more_about_connecting_account : messages.learn_more_about_smart_links;
  return /*#__PURE__*/React.createElement(React.Fragment, null, providerName ? /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.connect_unauthorised_account_description, {
    values: {
      context: providerName
    }
  })) : /*#__PURE__*/React.createElement(FormattedMessage, messages.connect_unauthorised_account_description_no_provider), ' ', /*#__PURE__*/React.createElement("a", {
    href: isProductIntegrationSupported ? CONTENT_URL_3P_ACCOUNT_AUTH : CONTENT_URL_SECURITY_AND_PERMISSIONS,
    target: "_blank",
    "data-testid": `${testId}-learn-more`,
    onClick: handleLearnMoreClick
  }, /*#__PURE__*/React.createElement(FormattedMessage, learnMoreMessage)));
};
export default UnauthorisedViewContent;